import React from "react";
import { DateTime } from "luxon";

import { Context } from "../../context";
import { Props } from "./types";
import { Year } from "./year";
import styles from "./styles.scss";

function isYearStart(dt: DateTime) {
  return dt.day === 1 && dt.month === 1;
}

function startYear(months: DateTime[][], startDate: DateTime) {
  return [...months, [startDate]];
}

function isInYear([firstDt]: DateTime[], dt: DateTime) {
  return firstDt.year === dt.year;
}

function findYearIndex(years: DateTime[][], dt: DateTime) {
  return years.findIndex((year) => isInYear(year, dt));
}

function addToYear(months: DateTime[][], dt: DateTime) {
  const index = findYearIndex(months, dt);

  return index >= 0
    ? [
        ...months.slice(0, index),
        [...months[index], dt],
        ...months.slice(index + 1),
      ]
    : [...months, [dt]];
}

function getYears(dates: DateTime[]) {
  return dates.reduce<DateTime[][]>(
    (months, dt) =>
      isYearStart(dt) ? startYear(months, dt) : addToYear(months, dt),
    [],
  );
}

function Years({ dates }: Props) {
  const { cell } = React.useContext(Context);

  return (
    <div className={styles.years}>
      {getYears(dates).map((year, index) => (
        <div
          key={index}
          className={styles.year}
          style={{
            width: cell.width * year.length,
            height: cell.height + (cell.height + cell.height * (1 / 3)),
          }}
        >
          <Year year={year} />
        </div>
      ))}
    </div>
  );
}

export { Years };
